export default function FooterSection() {
  return (
    <footer className="yasmin-footer">
      <img className="footer-roses footer-roses-left" src="/assets/rosas-footer-transparentes.png" alt="" />
      <img className="footer-roses footer-roses-right" src="/assets/rosas-footer-transparentes.png" alt="" />

      <div className="footer-content">
        <div className="footer-brand">
          <img className="footer-monogram" src="/assets/monograma-ysl.png" alt="Monograma Yasmin Siqueira" />
          <img className="footer-signature" src="/assets/assinatura-yasmin-horizontal.png" alt="Yasmin Siqueira XV" />
        </div>
        <div className="footer-divider" />
        <div className="footer-credits">
          <p>Organizado por</p>
          <a href="https://www.instagram.com/curionefestas/" target="_blank" rel="noreferrer" className="footer-company">
            CURIONE Festas e Assessoria
          </a>
          <a href="https://wa.me/5511934000505" target="_blank" rel="noreferrer" className="footer-whatsapp" aria-label="WhatsApp da Curione Festas">
            <i className="ri-whatsapp-line" /> +55 11 93400-0505
          </a>
          <i><b>◆◇◆</b></i>
          <p>Desenvolvido por</p>
          <a href="https://www.serraconsultoria.com" target="_blank" rel="noreferrer" className="footer-company">
            Serra Consultoria
          </a>
        </div>
      </div>
    </footer>
  );
}
